import { handleClose } from "./site-announcement-bar";

const siteHeader = document.querySelector(".site-header");

export default {
  init: () => {
    const scrollPixel = document.querySelector(".scroll-pixel");

    if (scrollPixel) {
      const observer = new IntersectionObserver(
        ([e]) => {
          siteHeader.classList.toggle("is-stuck", e.intersectionRatio < 1);

          const topBar = document.querySelector(".site-announcement-bar");

          if (window.innerWidth < 768) {
            if (siteHeader.classList.contains("is-stuck") && topBar) {
              handleClose();
            }
          }
        },
        {
          threshold: [1],
        },
      );

      observer.observe(document.querySelector(".scroll-pixel"));
    }

    document.addEventListener("DOMContentLoaded", function() {
      // Select the iframe using its title attribute
      let iframe = document.querySelector('iframe[title="Form powered and secured by Zeffy"]');

      if (iframe) {
          // Access the parent container of the iframe
          let iframeContainer = iframe.parentElement;

          // Add a custom class to the container div
          iframeContainer.classList.add('zeffy-iframe-container', 'max-w-3xl', 'mx-auto');
      }
   })
  },
};
